import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding: 16px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: ${({theme}) => theme.colors.interfacePure0};

    .label {
        font-size: 12px;
        color: ${({theme}) => theme.colors.interfaceGray500};
        font-weight: 500;
    }

    .parte {
        display: grid;
        grid-template-columns: 40px 1fr 32px;
        align-items: center;
        gap: 10px;
        background-color: rgba(0, 0, 100, 0.03);
        padding: 10px 20px 10px 10px;
        margin-top: 10px;
        border-radius: 8px;

        .iconc {
            background-color: ${({theme}) => theme.colors.interfacePure0};
            width: 35px;
            height: 35px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .info {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .nome {
                font-size: 14px;
                font-weight: bolder;
                color: ${({theme}) => theme.colors.interfaceText500};
            }

            .codigo {
                font-size: 10px;
                font-weight: 400;
                color: ${({theme}) => theme.colors.interfaceText500};
            }
        }
    }

    .parte-select {
        margin-top: 10px;
        align-items: center;
        display: flex;
        justify-content: center;
        flex: 1;
    }

    .parte-vazio {
        font-size: 0.875rem;
        color: ${(props: any) => props.theme.colors.c718096};
        font-style: italic;
        padding: 14px 20px;
        text-align: center;
        background-color: ${(props: any) => props.theme.colors.cf3f7fb};
        border-radius: 8px;
        border: 1px dashed ${(props: any) => props.theme.colors.ccbd5e0};
        margin-top: 12px;
    }
`;

export const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MenuButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 6px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    &:active {
        background-color: ${({ theme }) => theme.colors.interfacePure200 || '#E5E5E5'};
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        outline-offset: 2px;
    }
`;

export const MenuDropdown = styled.div`
    position: fixed;
    background: ${(props: any) => props.theme.colors.interfacePure0};
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 160px;
    z-index: 10000;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
`;

export const MenuItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    cursor: pointer;
    transition: background-color 0.2s ease;
    outline: none;

    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

